import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './App.css';
import MarketingPage from './pages/MarketingPage';

function NoMarketingPage() {
  const { t } = useTranslation();
  return (
    <div className="App-empty-state">
      <div className="App-empty-card">
        <h1>{t('app.noPageTitle')}</h1>
        <p>{t('app.noPageBody')}</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Marketing page - dynamic route by ID */}
          <Route path="/marketing/:id" element={<MarketingPage />} />
          {/* Missing/invalid marketing page links should not show demo vouchers */}
          <Route path="/" element={<NoMarketingPage />} />
          <Route path="*" element={<NoMarketingPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
